import { Billboard, Text } from "@react-three/drei";
import { useGameStore } from "../../stores/gameStore";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const EntityCorruptionBar = () => {
  const { entity } = useGameStore((state: any) => ({
    entity: state.entity,
  }));
  const { t } = useTranslation();

  // Memoizing static values like the text and colors to avoid unnecessary recalculation
  const corruptionText = useMemo(() => t("game.corruption"), [t]);

  return (
    <Billboard position-y={4.0}>
      {/* Text displaying corruption level */}
      <Text
        position={[0, 0.8, 0]}
        fontSize={0.5}
        color="#192330"
        anchorX="center"
        anchorY="middle"
      >
        {corruptionText}
      </Text>

      {/* Background bar */}
      <mesh position-z={-0.001}>
        <planeGeometry args={[4, 0.5]} />
        <meshBasicMaterial color="black" transparent opacity={0.5} />
      </mesh>

      {/* Corruption bar with optimized scaling */}
      <mesh
        scale-x={entity.corruptionLevel / 100}
        position-x={-2 * (1 - entity.corruptionLevel / 100)} // Adjusted position to center the bar
      >
        <planeGeometry args={[4, 0.5]} />
        <meshBasicMaterial color="#903C2D" />
      </mesh>
    </Billboard>
  );
};

export default EntityCorruptionBar;
